export interface MessageEventSource {
  isSourceOf: (event: MessageEvent) => boolean;
}

export class IFrameEventSource implements MessageEventSource {
  private readonly source: HTMLIFrameElement;

  constructor(source: HTMLIFrameElement) {
    this.source = source;
  }

  isSourceOf(event: MessageEvent) {
    return event.source === this.source.contentWindow;
  }
}

export class WindowEventSource implements MessageEventSource {
  private readonly source: Window;

  constructor(source: Window) {
    this.source = source;
  }

  isSourceOf(event: MessageEvent) {
    return event.source === this.source;
  }
}
